module.exports = __webpack_public_path__ + "img/ssbg4.69c71c5b.jpg";